import { useMutation } from "react-query"
import api from "../utils/api"

export default function useClientWorkspaceConsentRespond() {
  return useMutation({
    mutationFn: (response) => {
      return api.post('clientWorkplaceConsent', response)
    },
  })
}